/* ROXECOM — feedback videos as a swipeable slider.
   Rebuilds the #feedback grid (sections/landing.liquid) into cards that autoplay muted
   while visible, with a centred "tap for sound" button. Loaded before landing.js. */
(function () {
  'use strict';

  /* Videos that are not direct files in the section settings → their Shopify-hosted copy. */
  var OVERRIDES = {
    'vimeo.com/1191203652': {
      src: 'https://cdn.shopify.com/videos/c/vp/5cce7e689e8d4d16bc548f2515162420/5cce7e689e8d4d16bc548f2515162420.SD-480p-0.9Mbps-97119617.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/1071/4349/6017/files/preview_images/5cce7e689e8d4d16bc548f2515162420.thumbnail.0000000000.jpg?v=1791742545'
    }
  };
  var LABELS = {
    ar: 'ورّك هنا',
    it: "Tocca per l'audio",
    fr: 'Appuie pour le son',
    es: 'Toca para el sonido',
    en: 'Tap for sound'
  };
  var ICON_ON = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9.5v5h3.5L12 18.500V5.500L7.500 9.500z" fill="currentColor"/><path d="M15.500 9a4.200 4.200 0 0 1 0 6"/><path d="M18 6.500a7.800 7.800 0 0 1 0 11"/></svg>';
  var ICON_OFF = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9.500v5h3.500L12 18.500V5.500L7.500 9.500z" fill="currentColor"/><path d="M16 9.500l5 5"/><path d="M21 9.500l-5 5"/></svg>';

  var CSS = [
    '#feedback.rox-fb-on{background:linear-gradient(180deg,#2733E6 0%,#0B1A9C 100%);padding:44px 0 34px}',
    '#feedback.rox-fb-on .section-title{color:#fff}',
    '#feedback.rox-fb-on .section-subtitle{color:rgba(255,255,255,.88)}',
    '.rox-fb-slider{display:flex;gap:16px;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;margin:14px -16px 0;padding:10px 20px 18px;scroll-padding:0 20px}',
    '.rox-fb-slider::-webkit-scrollbar{display:none}',
    '.rox-fb-card{flex:0 0 auto;width:min(84vw,460px);scroll-snap-align:center;background:#fff;border:2px solid #0A1470;border-radius:26px;overflow:hidden;box-shadow:0 16px 36px rgba(2,7,80,.38);display:flex;flex-direction:column}',
    '.rox-fb-media{position:relative;aspect-ratio:16/9;background:#000}',
    '.rox-fb-media video,.rox-fb-media img{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;background:#000;display:block;border:0}',
    '.rox-fb-sound{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);z-index:2;display:inline-flex;align-items:center;gap:9px;padding:12px 22px;border:0;border-radius:999px;background:#F5B31E;color:#0A1470;font:800 1.05rem/1.2 Tajawal,Inter,system-ui,sans-serif;white-space:nowrap;cursor:pointer;box-shadow:0 10px 26px rgba(0,0,0,.45);-webkit-tap-highlight-color:transparent}',
    '.rox-fb-sound::after{content:"";position:absolute;inset:-7px;border-radius:999px;border:3px solid rgba(245,179,30,.75);animation:roxFbPulse 1.6s ease-out infinite;pointer-events:none}',
    '@keyframes roxFbPulse{0%{transform:scale(.92);opacity:.9}100%{transform:scale(1.22);opacity:0}}',
    '@media (prefers-reduced-motion:reduce){.rox-fb-sound::after{animation:none;opacity:.5}}',
    '.rox-fb-mute{position:absolute;top:10px;inset-inline-end:10px;z-index:2;display:none;place-items:center;box-sizing:border-box;width:38px;min-width:38px;height:38px;padding:0;border:0;border-radius:999px;background:rgba(255,255,255,.94);color:#0A1470;cursor:pointer;box-shadow:0 6px 16px rgba(0,0,0,.35)}',
    '.rox-fb-card.is-sound .rox-fb-sound{display:none}',
    '.rox-fb-card.is-sound .rox-fb-mute{display:grid}',
    '.rox-fb-card .feedback-video-title{display:block;-webkit-line-clamp:unset;overflow:visible;margin:0;padding:13px 16px 15px;color:#0f172a;font-size:1rem;font-weight:700;line-height:1.5;text-align:start}',
    '.rox-fb-dots{display:flex;justify-content:center;gap:8px;margin-top:4px}',
    '.rox-fb-dots button{width:9px;height:9px;padding:0;border:0;border-radius:999px;background:rgba(255,255,255,.4);cursor:pointer;transition:width .2s,background .2s}',
    '.rox-fb-dots button.is-active{width:26px;background:#F5B31E}',
    '@media (min-width:900px){.rox-fb-slider{justify-content:safe center;margin:14px 0 0}.rox-fb-card{width:420px}}'
  ].join('');

  function currentLang() {
    var l = '';
    try { l = localStorage.getItem('selectedLanguage') || ''; } catch (e) {}
    l = (l || document.documentElement.lang || 'ar').slice(0, 2).toLowerCase();
    return LABELS[l] ? l : 'ar';
  }
  function isFile(url) { return /\.(mp4|webm|mov|m4v)(\?|#|$)/i.test(url); }
  function resolve(url, thumb) {
    for (var k in OVERRIDES) {
      if (url.indexOf(k) !== -1 && OVERRIDES[k].src.indexOf('__') !== 0) {
        return { src: OVERRIDES[k].src, poster: OVERRIDES[k].poster || thumb };
      }
    }
    return { src: url, poster: thumb };
  }

  function build() {
    var section = document.getElementById('feedback');
    if (!section) return;
    var grid = section.querySelector('[data-feedback-grid]');
    if (!grid) return;
    var items = [].slice.call(grid.querySelectorAll('[data-feedback-video-item]'));
    if (!items.length) { grid.removeAttribute('data-feedback-grid'); return; }

    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    var slider = document.createElement('div');
    slider.className = 'rox-fb-slider';
    var dots = document.createElement('div');
    dots.className = 'rox-fb-dots';
    var cards = [];

    items.forEach(function (item, i) {
      var r = resolve(item.getAttribute('data-feedback-video-url') || '', item.getAttribute('data-feedback-video-thumb') || '');
      var card = document.createElement('article');
      card.className = 'rox-fb-card';
      var media = document.createElement('div');
      media.className = 'rox-fb-media';
      card.appendChild(media);

      var video = null;
      if (isFile(r.src)) {
        video = document.createElement('video');
        video.muted = true; video.defaultMuted = true; video.loop = true; video.playsInline = true;
        video.setAttribute('muted', ''); video.setAttribute('playsinline', ''); video.setAttribute('webkit-playsinline', '');
        video.preload = 'none';
        if (r.poster) video.poster = r.poster;
        video.setAttribute('data-src', r.src);
        var hd = item.getAttribute('data-feedback-video-hd') || '';
        if (isFile(hd)) video.setAttribute('data-hd', hd);
        media.appendChild(video);

        var sound = document.createElement('button');
        sound.type = 'button'; sound.className = 'rox-fb-sound';
        sound.innerHTML = ICON_ON + '<span></span>';
        media.appendChild(sound);
        var mute = document.createElement('button');
        mute.type = 'button'; mute.className = 'rox-fb-mute'; mute.setAttribute('aria-label', 'Mute');
        mute.innerHTML = ICON_OFF;
        media.appendChild(mute);
        sound.addEventListener('click', function () { soundOn(c); });
        mute.addEventListener('click', function () { soundOff(c); });
      } else {
        /* not a direct video file: keep it reachable as a link with its thumbnail */
        var a = document.createElement('a');
        a.href = r.src; a.target = '_blank'; a.rel = 'noopener';
        a.innerHTML = r.poster ? '<img alt="" loading="lazy" src="' + r.poster.replace(/"/g, '&quot;') + '">' : '';
        media.appendChild(a);
      }

      var title = item.querySelector('.feedback-video-title');
      if (title) card.appendChild(title);          /* keeps its data-key → still translated by landing.js */
      slider.appendChild(card);

      var dot = document.createElement('button');
      dot.type = 'button'; dot.setAttribute('aria-label', String(i + 1));
      dot.addEventListener('click', function () { card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); });
      dots.appendChild(dot);

      var c = { card: card, video: video, dot: dot, ratio: 0 };
      cards.push(c);
    });

    function load(c) {
      if (c.video && !c.video.getAttribute('src')) c.video.src = c.video.getAttribute('data-src');
    }
    function soundOff(c) {
      if (!c.video) return;
      c.video.muted = true; c.video.controls = false;
      c.card.classList.remove('is-sound');
    }
    function soundOn(c) {
      if (!c.video) return;
      cards.forEach(function (o) { if (o !== c) { soundOff(o); if (o.video) o.video.pause(); } });
      /* muted preview streams the light file; with sound we restart on the sharper one */
      var hd = c.video.getAttribute('data-hd');
      if (hd && c.video.getAttribute('src') !== hd) c.video.src = hd; else load(c);
      c.video.muted = false; c.video.controls = true;
      try { c.video.currentTime = 0; } catch (e) {}
      c.card.classList.add('is-sound');
      var p = c.video.play();
      if (p && p.catch) p.catch(function () {});
    }
    var active = null;
    function setActive(c) {
      if (active === c) return;
      active = c;
      cards.forEach(function (o) {
        o.dot.classList.toggle('is-active', o === c);
        if (o !== c && o.video) { soundOff(o); o.video.pause(); }
      });
      if (c && c.video) {
        load(c);
        var p = c.video.play();
        if (p && p.catch) p.catch(function () {});
      }
    }
    function labels() {
      var t = LABELS[currentLang()];
      cards.forEach(function (c) {
        var s = c.card.querySelector('.rox-fb-sound span');
        if (s) s.textContent = t;
      });
    }

    grid.parentNode.insertBefore(slider, grid);
    grid.parentNode.insertBefore(dots, grid);
    grid.parentNode.removeChild(grid);
    section.classList.add('rox-fb-on');
    section.dataset.feedbackGridInit = '1';
    labels();
    document.addEventListener('muh:languageChanged', labels);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          cards.forEach(function (c) { if (c.card === e.target) c.ratio = e.isIntersecting ? e.intersectionRatio : 0; });
        });
        var best = null;
        cards.forEach(function (c) { if (c.ratio >= 0.6 && (!best || c.ratio > best.ratio)) best = c; });
        setActive(best);
      }, { threshold: [0, 0.3, 0.6, 0.8, 1] });
      cards.forEach(function (c) { io.observe(c.card); });
    } else {
      setActive(cards[0]);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) cards.forEach(function (c) { if (c.video) c.video.pause(); });
      else if (active && active.video) { var p = active.video.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }

  function run() {
    try { build(); } catch (e) { document.documentElement.classList.add('rox-fb-fail'); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
